/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge3S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zM9.555 13.85v1.33c.273.147.586.257.94.33.353.08.72.12 1.1.12.58 0 1.08-.097 1.5-.29a2.19 2.19 0 0 0 .98-.83c.226-.367.34-.8.34-1.3 0-.567-.177-1.037-.53-1.41-.347-.38-.844-.607-1.49-.68l1.72-1.76V8.33h-4.43V9.6h2.45l-1.8 1.9.49.82a2.85 2.85 0 0 1 1.02-.19c.38 0 .666.093.86.28.2.187.3.45.3.79 0 .36-.127.637-.38.83-.254.193-.617.29-1.09.29-.327 0-.67-.04-1.03-.12a3.969 3.969 0 0 1-.95-.35z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBadge3S as Badge3S };
